/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import Tab from '../../shared/state/tab';

export const getNavigationTabs = () => {

    const navigationTabs = [];

    navigationTabs.push(new Tab({
        label: 'Dealer Details',
        route: '/rga/recalled/advance-returned?tab=dealerInfo'
    }));

    navigationTabs.push(new Tab({
        label: 'Cosignment Details',
        route: '/rga/recalled/advance-returned?tab=consignmentInfo'
    }));

    return navigationTabs;

};



// WEBPACK FOOTER //
// ./src/rga/shared/advance-returned-part-navigation-helper.js